import styled from '@emotion/styled';
import { createElement, FC, RefObject, useEffect } from 'react';

export interface Props {
  src: string;
  loop?: boolean;
  muted?: boolean;
  autoPlay?: boolean;
  controls?: boolean;
  nodownload?: boolean;
  poster?: string;
  videoRef?: RefObject<HTMLVideoElement>;
  onMount?: (el: HTMLVideoElement) => void;
  onSeek?: (time: number) => void;
  onTimeUpdate?: (time: number) => void;
  className?: string;
}

const VideoScreen: FC<Props> = ({
  src,
  loop,
  muted = true,
  autoPlay,
  controls,
  nodownload,
  poster,
  videoRef,
  onMount = () => undefined,
  onSeek = () => undefined,
  onTimeUpdate = () => undefined,
  className,
}) => {
  useEffect(() => {
    if (videoRef && videoRef.current !== null) {
      onMount(videoRef.current);
    }
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root
      loop={loop}
      muted={muted}
      autoPlay={autoPlay}
      controls={controls}
      poster={poster}
      controlsList={nodownload ? 'nodownload' : undefined}
      ref={videoRef}
      onSeeking={(e: any) => {
        onSeek(e.currentTarget.currentTime);
      }}
      onTimeUpdate={(e: any) => {
        onTimeUpdate(e.currentTarget.currentTime);
      }}
      className={className}
      key={src}
    >
      <source src={src} />
    </Root>
  );
};

const Root = styled('video')({
  backgroundColor: '#000',
  objectFit: 'contain',
  width: '100%',
  height: '100%',
});

export default VideoScreen;
